<template>
    <div class="honorAptitude">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px" label-position='right'>
        <el-form-item label="荣誉简述：" prop="honorSketch">
          <el-input type="textarea"
          v-model="form.honorSketch"
          :autosize='{ minRows: 6, maxRows: 6 }'
          :maxlength="250"
          placeholder="请输入荣誉简述，最多250个字符"
          class="input-box">
          </el-input>
        </el-form-item>

        <el-form-item label="荣誉资质图片：">
              <multi-upload v-model="gloryImgList"
                :keyid="gloryImgList"
                :imgWidth='1200'
                :imgHeight='600'
                :typeArray="['png']"
                :maxCount='99'
                :sizetxt='String("建议像素303*216,PNG，不超过10M")'>
              </multi-upload>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>

import MultiUpload from '../../../components/multiUpload.vue'
export default {
  name: 'honorAptitude',
  props: {

  },
  components: {
    // UploadBtn
    MultiUpload
  },
  data () {
    return {
      form: {
        honorSketch: '' // 荣誉简述
      },
      gloryImgList: [], // 荣誉资质
      rules: {
        honorSketch: [
          { message: '请输入荣誉简述', trigger: 'blur' },
          { min: 1, max: 250, message: '最多250个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {

  },
  created () {
    this.getGardenBaseInfo()
    // this.preview()
  },
  mounted () {
    this.$parent.activeIndex = '6'

    this.$eventBus.$on('surverSave', () => {
      console.log('荣誉资质信息事件')
      this.honorInfo()
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('surverSave')
  },
  methods: {
    // 初始化园区信息
    async getGardenBaseInfo () {
      try {
        const res = await this.$get(this.$url.gardenInfoManage.gardenBaseInfo)

        const { code, msg, data } = res.data
        if (code === 200) {
          this.form.honorSketch = data.extra.honorIntroduction ? data.extra.honorIntroduction : '' // 荣誉简述
          this.gloryImgList = data.extra.honorPicture ? data.extra.honorPicture.split(',') : '' // 荣誉资质图片
          // console.log(this.gloryImgList)
          // console.log(data.extra)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // // 保存数据
    // async saveGarenInfo5 () {
    //   const res = await this.$post(this.$url.gardenInfoManage.gardenUpLoadInfo, {
    //     honorIntroduction: this.form.honorSketch ? this.form.honorSketch : '', // 荣誉简述
    //     honorPicture: this.gloryImgList ? this.gloryImgList.join(',') : '' // 荣誉资质图片
    //   })

    //   const { code, msg } = res.data

    //   if (code === 200) {
    //     this.$emit('updata', code)
    //     // this.$message.success('保存成功!')
    //     console.log('保存成功!')
    //   } else {
    //     this.$message.error(msg)
    //   }
    // }

    // 荣誉资质本地保存数据
    honorInfo () {
      const ShonorInfo = {
        honorIntroduction: this.form.honorSketch ? this.form.honorSketch : '', // 荣誉简述
        honorPicture: this.gloryImgList ? this.gloryImgList.join(',') : '' // 荣誉资质图片
      }
      sessionStorage.setItem('LhonorInfo', JSON.stringify(ShonorInfo))
    }

    // // 预览
    // preview () {
    //   const previewData = {
    //     honorIntroduction: this.form.honorSketch ? this.form.honorSketch : null, // 荣誉简述
    //     honorPicture: this.gloryImgList ? this.gloryImgList.join(',') : null // 荣誉资质图片
    //   }
    //   sessionStorage.setItem('gardenDataHonorView', JSON.stringify(previewData))
    // }

  }
}
</script>

<style scoped lang="less">
.input-box{
  width: 720px;
}
</style>
